import * as THREE from 'three';
import { PLANET_R } from '../config.js';
import { surfaceRadius } from './planet.js';
import { colliders } from './colliders.js';

const UP_Y = new THREE.Vector3(0, 1, 0);
const _ray = new THREE.Raycaster();
const _origin = new THREE.Vector3();
const _dir    = new THREE.Vector3();

// Actual mesh-surface radius at a direction. Casts a ray from outside the
// planet inward and uses the first triangle hit — props land flush on the
// flat triangle faces instead of floating above the smooth analytical curve.
// Falls back to the analytical height if somehow no triangle is hit.
export function groundRadius(planet, direction) {
  _origin.copy(direction).multiplyScalar(PLANET_R * 2);
  _dir.copy(direction).negate();
  _ray.set(_origin, _dir);
  const hits = _ray.intersectObject(planet, false);
  return hits.length > 0 ? hits[0].point.length() : surfaceRadius(direction);
}

// Orients and positions a prop so its local +Y faces outward, then registers a
// cylindrical collider (if the prop declares one via userData).
export function placeOnPlanet(obj, direction, planet) {
  obj.quaternion.setFromUnitVectors(UP_Y, direction);
  obj.position.copy(direction).multiplyScalar(groundRadius(planet, direction));

  const scale = 0.85 + Math.random() * 0.55;
  obj.scale.setScalar(scale);
  obj.rotateOnAxis(UP_Y, Math.random() * Math.PI * 2);

  if (obj.userData.collideR) {
    colliders.push({
      pos: obj.position.clone(),
      up:  obj.position.clone().normalize(),
      r:   obj.userData.collideR * scale,
      h:   obj.userData.collideH * scale,
    });
  }
}
